import Paper from '@mui/material/Paper';
import styled from '@mui/material/styles/styled';

const TableContainer = styled(Paper)(({ theme }) => ({
  overflow: 'hidden'
}));

export default TableContainer;
